/**
 * GENERATED — do not edit by hand.
 * Regenerate with: node scripts/import-open-design-themes.mjs
 *
 * Theme presets adapted from nexu-io/open-design (Apache-2.0),
 * commit 024e6d8. Only generic-aesthetic systems are imported; brand-named
 * design systems are excluded. Each preset maps that system's tokens.css onto
 * our ThemeTokens (see docs/superpowers/specs for the mapping).
 */
import type { ThemeTokens } from "./ThemeStyleInjector";

export type ThemePreset = {
  id: string;
  /** Neutral display label shown in the preset gallery. */
  name: string;
  /** Source aesthetic slug (provenance). */
  aesthetic: string;
  tokens: ThemeTokens;
  /**
   * Optional id of a LAYOUT recipe (see @dynamic-landing/layout). When set, a
   * design doesn't just recolor — Make's Design tab offers an "Apply layout"
   * button that RESTRUCTURES the current page into that layout. Set on the
   * hand-curated presets in themePresetsManual.ts (the generated array below
   * never carries one).
   */
  recipe?: string;
};

export const THEME_PRESETS: ThemePreset[] = [
  {
    "id": "bold",
    "name": "Bold",
    "aesthetic": "bold",
    "tokens": {
      "colors": {
        "brand": "#111111",
        "brandHover": "#101010",
        "onBrand": "#ffffff",
        "accent": "#111111",
        "onAccent": "#ffffff",
        "surface": "#ffffff",
        "onSurface": "#111111",
        "contrast": "#111111",
        "onContrast": "#ffffff",
        "success": "#168a46",
        "warning": "#b7791f",
        "danger": "#c53030"
      },
      "font": {
        "body": "inter"
      }
    }
  },
  {
    "id": "clean",
    "name": "Clean",
    "aesthetic": "clean",
    "tokens": {
      "colors": {
        "brand": "#111111",
        "brandHover": "#101010",
        "onBrand": "#ffffff",
        "accent": "#111111",
        "onAccent": "#ffffff",
        "surface": "#ffffff",
        "onSurface": "#111111",
        "contrast": "#111111",
        "onContrast": "#ffffff",
        "success": "#168a46",
        "warning": "#b7791f",
        "danger": "#c53030"
      },
      "font": {
        "display": "inter",
        "body": "inter"
      }
    }
  },
  {
    "id": "contemporary",
    "name": "Contemporary",
    "aesthetic": "contemporary",
    "tokens": {
      "colors": {
        "brand": "#2563eb",
        "brandHover": "#225bd8",
        "onBrand": "#ffffff",
        "accent": "#2563eb",
        "onAccent": "#ffffff",
        "surface": "#f5f8ff",
        "onSurface": "#101828",
        "contrast": "#101828",
        "onContrast": "#f5f8ff",
        "success": "#16a34a",
        "warning": "#f59e0b",
        "danger": "#ef4444"
      },
      "font": {
        "display": "inter",
        "body": "inter"
      }
    }
  },
  {
    "id": "corporate",
    "name": "Corporate",
    "aesthetic": "corporate",
    "tokens": {
      "colors": {
        "brand": "#2563eb",
        "brandHover": "#225bd8",
        "onBrand": "#ffffff",
        "accent": "#2563eb",
        "onAccent": "#ffffff",
        "surface": "#f5f8ff",
        "onSurface": "#101828",
        "contrast": "#101828",
        "onContrast": "#f5f8ff",
        "success": "#16a34a",
        "warning": "#f59e0b",
        "danger": "#ef4444"
      },
      "font": {
        "display": "inter",
        "body": "inter"
      }
    }
  },
  {
    "id": "editorial",
    "name": "Editorial",
    "aesthetic": "editorial",
    "tokens": {
      "colors": {
        "brand": "#9a5a2f",
        "brandHover": "#8e532b",
        "onBrand": "#ffffff",
        "accent": "#9a5a2f",
        "onAccent": "#ffffff",
        "surface": "#fbf7f0",
        "onSurface": "#1f1a16",
        "contrast": "#1f1a16",
        "onContrast": "#fbf7f0",
        "success": "#4f8a4f",
        "warning": "#c9822f",
        "danger": "#b33a3a"
      },
      "font": {
        "mono": "ibm-plex-mono"
      }
    }
  },
  {
    "id": "elegant",
    "name": "Elegant",
    "aesthetic": "elegant",
    "tokens": {
      "colors": {
        "brand": "#9b5b32",
        "brandHover": "#8f542e",
        "onBrand": "#ffffff",
        "accent": "#9b5b32",
        "onAccent": "#ffffff",
        "surface": "#fbf6ee",
        "onSurface": "#201914",
        "contrast": "#201914",
        "onContrast": "#fbf6ee",
        "success": "#4f8a4f",
        "warning": "#c9822f",
        "danger": "#b33a3a"
      },
      "font": {
        "body": "inter"
      }
    }
  },
  {
    "id": "enterprise",
    "name": "Enterprise",
    "aesthetic": "enterprise",
    "tokens": {
      "colors": {
        "brand": "#1d4ed8",
        "brandHover": "#1b48c7",
        "onBrand": "#ffffff",
        "accent": "#1d4ed8",
        "onAccent": "#ffffff",
        "surface": "#f8fafc",
        "onSurface": "#0f172a",
        "contrast": "#0f172a",
        "onContrast": "#f8fafc",
        "success": "#15803d",
        "warning": "#b45309",
        "danger": "#b91c1c"
      },
      "font": {
        "display": "inter",
        "body": "inter",
        "mono": "ibm-plex-mono"
      }
    }
  },
  {
    "id": "flat",
    "name": "Flat",
    "aesthetic": "flat",
    "tokens": {
      "colors": {
        "brand": "#2563eb",
        "brandHover": "#225bd8",
        "onBrand": "#ffffff",
        "accent": "#2563eb",
        "onAccent": "#ffffff",
        "surface": "#f5f8ff",
        "onSurface": "#101828",
        "contrast": "#101828",
        "onContrast": "#f5f8ff",
        "success": "#16a34a",
        "warning": "#f59e0b",
        "danger": "#ef4444"
      },
      "font": {
        "display": "inter",
        "body": "inter"
      }
    }
  },
  {
    "id": "glassmorphism",
    "name": "Glassmorphism",
    "aesthetic": "glassmorphism",
    "tokens": {
      "colors": {
        "brand": "#4f8cff",
        "brandHover": "#4981eb",
        "onBrand": "#ffffff",
        "accent": "#4f8cff",
        "onAccent": "#ffffff",
        "surface": "#eef6ff",
        "onSurface": "#102033",
        "contrast": "#102033",
        "onContrast": "#eef6ff",
        "success": "#22c55e",
        "warning": "#f59e0b",
        "danger": "#ef4444"
      },
      "font": {
        "display": "inter",
        "body": "inter"
      }
    }
  },
  {
    "id": "gradient",
    "name": "Gradient",
    "aesthetic": "gradient",
    "tokens": {
      "colors": {
        "brand": "#7c3aed",
        "brandHover": "#7235da",
        "onBrand": "#ffffff",
        "accent": "#7c3aed",
        "onAccent": "#ffffff",
        "surface": "#f7f3ff",
        "onSurface": "#191225",
        "contrast": "#191225",
        "onContrast": "#f7f3ff",
        "success": "#10b981",
        "warning": "#f59e0b",
        "danger": "#ef4444"
      },
      "font": {
        "display": "inter",
        "body": "inter",
        "mono": "geist-mono"
      }
    }
  },
  {
    "id": "luxury",
    "name": "Luxury",
    "aesthetic": "luxury",
    "tokens": {
      "colors": {
        "brand": "#c6a15b",
        "brandHover": "#b69454",
        "onBrand": "#080706",
        "accent": "#c6a15b",
        "onAccent": "#080706",
        "surface": "#080706",
        "onSurface": "#fff8ea",
        "contrast": "#fff8ea",
        "onContrast": "#080706",
        "success": "#5fa36a",
        "warning": "#d8a94f",
        "danger": "#d85a52"
      },
      "font": {
        "body": "inter"
      }
    }
  },
  {
    "id": "material",
    "name": "Material",
    "aesthetic": "material",
    "tokens": {
      "colors": {
        "brand": "#1a73e8",
        "brandHover": "#186ad5",
        "onBrand": "#ffffff",
        "accent": "#1a73e8",
        "onAccent": "#ffffff",
        "surface": "#f8fafd",
        "onSurface": "#202124",
        "contrast": "#202124",
        "onContrast": "#f8fafd",
        "success": "#188038",
        "warning": "#f9ab00",
        "danger": "#d93025"
      }
    }
  },
  {
    "id": "minimal",
    "name": "Minimal",
    "aesthetic": "minimal",
    "tokens": {
      "colors": {
        "brand": "#111111",
        "brandHover": "#101010",
        "onBrand": "#ffffff",
        "accent": "#111111",
        "onAccent": "#ffffff",
        "surface": "#ffffff",
        "onSurface": "#111111",
        "contrast": "#111111",
        "onContrast": "#ffffff",
        "success": "#168a46",
        "warning": "#b7791f",
        "danger": "#c53030"
      },
      "font": {
        "display": "inter",
        "body": "inter"
      }
    }
  },
  {
    "id": "modern",
    "name": "Modern",
    "aesthetic": "modern",
    "tokens": {
      "colors": {
        "brand": "#4f46e5",
        "brandHover": "#4940d3",
        "onBrand": "#ffffff",
        "accent": "#4f46e5",
        "onAccent": "#ffffff",
        "surface": "#f7f8fc",
        "onSurface": "#111827",
        "contrast": "#111827",
        "onContrast": "#f7f8fc",
        "success": "#10b981",
        "warning": "#f59e0b",
        "danger": "#ef4444"
      },
      "font": {
        "display": "inter",
        "body": "inter",
        "mono": "geist-mono"
      }
    }
  },
  {
    "id": "mono",
    "name": "Monochrome",
    "aesthetic": "mono",
    "tokens": {
      "colors": {
        "brand": "#111111",
        "brandHover": "#101010",
        "onBrand": "#ffffff",
        "accent": "#111111",
        "onAccent": "#ffffff",
        "surface": "#ffffff",
        "onSurface": "#111111",
        "contrast": "#111111",
        "onContrast": "#ffffff",
        "success": "#168a46",
        "warning": "#b7791f",
        "danger": "#c53030"
      },
      "font": {
        "display": "ibm-plex-mono",
        "body": "ibm-plex-mono",
        "mono": "ibm-plex-mono"
      }
    }
  },
  {
    "id": "neobrutalism",
    "name": "Neo-Brutalism",
    "aesthetic": "neobrutalism",
    "tokens": {
      "colors": {
        "brand": "#d24b1f",
        "brandHover": "#c1451d",
        "onBrand": "#ffffff",
        "accent": "#d24b1f",
        "onAccent": "#ffffff",
        "surface": "#fff4cf",
        "onSurface": "#2a1810",
        "contrast": "#2a1810",
        "onContrast": "#fff4cf",
        "success": "#3d8f4f",
        "warning": "#f2a93b",
        "danger": "#b83a2f"
      },
      "font": {
        "body": "inter"
      }
    }
  }
];
